/*
 * The module wraps the browser's local storage and provides a simple interface
 * to get, set, unset and find values.
 *
 * Several options are provided to control the behavior of the store:
 * - `format`: the format of the value to store. It can be `json` or `raw`.
 */

import {
  createWebStore,
  type WebStoreFormat,
  type WebStoreOptions,
} from "@/services/web-storage";

/*
 * Constants
 */

export namespace Browser {
  export namespace Store {
    export type Format = WebStoreFormat;
    export type Options = WebStoreOptions;

    export const DEFAULT_OPTIONS = {
      format: "json",
    };
  }
}

/*
 * Public functions
 */

const store = createWebStore(() => {
  const storage = window.localStorage;
  if (!storage) {
    throw new Error("Local storage is not available");
  }
  return storage;
});

export const browser = {
  utils: {
    /** Strip the site-name suffix browsers append to page titles (e.g. "Pricing | Routine" → "Pricing"). */
    cleanTitle(title: string | undefined): string | undefined {
      if (!title) return undefined;
      const cleaned = title.split(/\s[|–—\-:•·]\s/)[0].trim();
      return cleaned || undefined;
    },
  },

  store,
};
